module.exports = __webpack_public_path__ + "media/images/404-error-image-49388738a1cd473b1ff9b8851627cbc3.svg";